import React, { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { HIDDEN_PATHS, PATHS } from './registry/paths';
import { PAGES } from './registry/pages';
import SplashPage from './splash/SplashPage';
import { installGlobalCapture } from './debug/debugLog';

installGlobalCapture();

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<p className="ms-sr-only" role="status">Loading...</p>}>
        <Routes>
          {[...PATHS, ...HIDDEN_PATHS].map(({ id, path }) => {
            const Page = PAGES[id];
            return <Route key={id} path={`${path}/*`} element={<Page />} />;
          })}
          {/* links from the old two-page version */}
          <Route path="/npcathon" element={<Navigate to="/dnd#npcs" replace />} />
          <Route path="/magic-me" element={<Navigate to="/dnd#speak" replace />} />
          <Route path="/good-morning-hitler" element={<Navigate to="/gmh" replace />} />
          <Route path="/goodmorninghitler" element={<Navigate to="/gmh" replace />} />
          <Route path="*" element={<SplashPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
